import { IImageInputControl } from '@infotech-soe/metaschema';

import {
  FormControlViewModelType,
  ImageInputFormControlViewModel,
  LocalizedProps,
} from '../../view-model/FormControlViewModel';

const buildImageInputControl = async (
  item: IImageInputControl,
  localizedProps: LocalizedProps
): Promise<ImageInputFormControlViewModel> => ({
  alt: item.alt,
  columns: item.columns,
  disabled: item.disabled,
  hasValue: true,
  hasHistory: false,
  height: item.height,
  name: item.name,
  noLabel: item.noLabel,
  objectFit: item.objectFit,
  predefinedValue: item.predefinedValue,
  type: FormControlViewModelType.IMAGE,
  changed: false,
  value: null,
  visible: item.visible,
  ...localizedProps,
});

export default buildImageInputControl;
